import React from 'react'
import { string } from 'prop-types'
import { getThirdpartyDesclaimer } from 'services/utils/third-party'

const LoginDisclaimer = ({ requestOrigin }) => {
  const thirdParty =
  requestOrigin === 'voice' ? 'Google' : requestOrigin.toUpperCase()
  return (
    <div className="co-login-disclaimer" data-testid="co-login-disclaimer">
      <p dangerouslySetInnerHTML={getThirdpartyDesclaimer(thirdParty)} />
    </div>
  )
}

LoginDisclaimer.propTypes = {
  requestOrigin: string,
}

LoginDisclaimer.defaultProps = {
  requestOrigin: '',
}

export default LoginDisclaimer
